module.exports = __webpack_public_path__ + "www/1670826376000/img/app-07.ca30a8f.png";